import styled from 'styled-components';

export const StyledSimpleBarChart = styled.div`
  width: 100%;

  &.simple-bar-chart {
    flex-direction: column;
    
    @media screen and (max-width: 850px) {
      margin-top: 30px;
    }
  }

  &.bar-chart {
    @media screen and (max-width: 1366px) {
      display: flex;
      margin: 0 auto;
    }
  }
  
    @media screen and (max-width: 1366px) {
      margin-bottom: 30px;
    }

  .recharts-wrapper .recharts-default-legend {
    text-align: left !important;
    position: relative !important;
    left: 122px !important;
    
    @media screen and (max-width: 1600px) {
      left: 20px;
    }
  }
  
  svg {
    margin-top: -27px;
    font-size: 14px !important;
    overflow: inherit;
    
    @media screen and (max-width: 1366px) {
      display: flex;
      margin: 0 auto;
    }
    
    text {
      font-weight: bold;
    }
  }
`;
